import React from 'react';
import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import '../reset.css';
import styles from './index.css';

import Header from '../../components/header/';
import Navigation from '../../components/navigation/';
import Footer from '../../components/footer/';
import VerticalNav from './verticalNav/';
import AboutUs from './aboutUs/';

class Layout extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { header, navigation, footer, intro, frameWork, sendword, shortVideo } = content;

        const aboutUs = {
            intro,
            frameWork,
            sendword,
            shortVideo,
        };

        return (
            <div>
                <Header content={header} />
                <Navigation content={navigation} />
                <div className={styles.mainBody}>
                    <VerticalNav />
                    <AboutUs content={aboutUs} />
                </div>
                <Footer content={footer} />
                <ChipEdit />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export default Layout;
